module.exports = "./img/d06ea38fb7eba2d6a41a33162286733a.jpg";